import styled from "styled-components";
import Casa from "./Images/Casa.png";
import Apartamento from "./Images/Apartamento.png";
import Comercio from "./Images/Comercio.png";

export const DivFlex = styled.div`
  @media (max-width: 700px) {
    display: flex;
  }
`;

export const DivForm = styled.div`
  .Invalido {
    display: block;
    color: #bc0000;
    font-size: 12px;
    margin-left: 5px;
    margin-top: 12px;
    font-weight: bold;
    font-family: Open Sans, sans-serif;
  }

  @media (max-width: 700px) {
    .Invalido {
      margin-top: 30px;
      margin-bottom: 0px;
    }
  }

  .InvalidoDisabled {
    display: none;
  }
`;

export const DivImages = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  display: grid;
  max-width: 620px;
  grid-column-gap: 35px;
  justify-content: center;
  grid-template-columns: auto auto auto;
  font-style: normal;
  font-family: "Open Sans", sans-serif;

  @media (max-width: 700px) {
    overflow-x: auto;
    grid-column-gap: 25px;
  }

  input[type="radio"] {
    display: none;
  }

  input[type="radio"]:hover + label {
    outline: 1px solid #6c5af4;
  }

  input[type="radio"]:checked + label {
    outline: 1px solid #6c5af4;
  }

  input[type="radio"]:checked {
    outline: 1px solid #6c5af4;
  }

  div {
    margin-top: 150px;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #616161;
    @media (max-width: 700px) {
      margin-top: 10px;
      margin-left: 0px;
    }
  }

  .apartamento {
    float: left;
    width: 196px;
    height: 196px;
    border-radius: 20px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-color: #f5f5f5;
    background-image: url(${Apartamento});
    background-position: 50%;

    div {
      margin-top: 150px;
      margin-left: 76px;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #616161;
      @media (max-width: 700px) {
        margin-top: 125px;
        margin-left: 59px;
      }
    }

    @media (max-width: 700px) {
      margin-right: 0;
      margin-bottom: 14px;
      width: 159px;
      height: 159px;
    }
  }

  .casa {
    float: left;
    width: 196px;
    height: 196px;
    border-radius: 20px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-color: #f5f5f5;
    background-image: url(${Casa});
    background-position: 50%;

    div {
      margin-top: 140px;
      width: 97px;
      margin-left: 49px;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #616161;
      text-align: center;
      @media (max-width: 700px) {
        margin-top: 120px;
        margin-top: 121px;
        margin-left: 32px;
        font-size: 15px;
        line-height: 16px;
      }
    }

    @media (max-width: 700px) {
      margin-right: 0;
      margin-bottom: 14px;
      width: 159px;
      height: 159px;
      margin-left: 175px;
    }
  }

  .comercio {
    float: left;
    width: 196px;
    height: 196px;
    border-radius: 20px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-color: #f5f5f5;
    background-image: url(${Comercio});
    background-position: 50%;

    div {
      margin-left: 60px;
    }

    @media (max-width: 700px) {
      width: 159px;
      height: 159px;
      margin-bottom: 14px;
    }

    div {
      @media (max-width: 700px) {
        margin-top: 125px;
        margin-left: 45px;
      }
    }
  }
`;

export const TitleText = styled.div`
  font-family: "Kanit";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 113%;
  text-align: center;
  color: #212121;
  padding-top: 52px;
  text-align: center;

  @media (max-width: 700px) {
    width: calc(100% - 88px);
    margin: 0 auto;
  }
`;

export const ChoiceText = styled.div`
  font-family: "Open Sans", sans-serif;
  width: 440px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #212121;
  margin: 48px auto 16px;
  text-align: center;
  @media (max-width: 700px) {
    text-align: center;
    width: 100%;
    margin: 16px auto 16px;
  }
`;

export const DivInput = styled.div`
  width: 664px;
  height: 56px;
  margin-left: auto;
  margin-right: auto;
  .buttonSend {
    width: 664px;
    height: 52px;
    color: #ffffff;
    background: #6c5af4;
    border-radius: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    font-weight: 700;
    font-size: 16px;
    @media (max-width: 700px) {
      width: 380px;
      height: 52px;
    }
  }

  .buttonSend:hover {
    color: #6c5af4;
    background: #ffffff;
    border: 1px solid #6c5af4;
  }
  .input-AXS {
    width: 654px;
  }

  .input-AXS input {
    width: 654px;
  }

  .MuiTextField-root > .MuiFormLabel-root.Mui-focused {
    color: #757575;
  }

  .MuiInputLabel-outlined {
    z-index: 1;
    -webkit-transform: translate(14px, 20px) scale(1);
    -ms-transform: translate(14px, 20px) scale(1);
    transform: translate(14px, 20px) scale(1);
    pointer-events: none;
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -8px) scale(0.75);
  }

  @media (max-width: 700px) {
    margin: 0 auto 32px;
  }
  @media (max-width: 700px) {
    width: 344px;
    height: 56px;
    display: block;
    margin-left: auto;
    margin-right: auto;

    .input-AXS {
      width: 380px;
    }

    .input-AXS input {
      width: 380px;
    }
  }
`;

export const DivAutocomplete = styled.div`
  height: 56px;
  @media (max-width: 700px) {
    margin-top: 16px;
    width: 344px;
    .MuiOutlinedInput-root {
      height: 56px;
      width: 344px;
    }
  }
  background: #f5f5f5;
  border-radius: 8px;

  .MuiOutlinedInput-notchedOutline {
    font-family: "Open Sans", sans-serif;
    border: none;
  }

  .MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
    font-family: "Open Sans", sans-serif;
    color: #757575;
    font-size: 16px;
  }

  .MuiOutlinedInput-root {
    font-family: "Open Sans", sans-serif;
    height: 56px;
  }

  .MuiInputLabel-outlined.MuiInputLabel-marginDense {
    font-family: "Open Sans", sans-serif;
    transform: translate(14px, 16px) scale(1);
    color: #757575;
  }

  .MuiAutocomplete-root .MuiAutocomplete-input {
    color: #757575;
  }

  .MuiAutocomplete-input {
    padding: 2.5px 4px 2.5px 14px;
  }

  .MuiInputLabel-outlined {
    font-family: "Open Sans", sans-serif;
    z-index: 1;
    -webkit-transform: translate(14px, 16px) scale(1);
    -ms-transform: translate(14px, 16px) scale(1);
    transform: translate(14px, 16px) scale(1);
    pointer-events: none;
    left: 7px;
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    font-family: "Open Sans", sans-serif;
    transform: translate(14px, -8px) scale(0.75);
  }
`;

export const DivMobile = styled.div`
  .SetaProposta {
    margin-top: auto;
    margin-bottom: auto;
    transform: scaleX(-1);
    cursor: pointer;
    margin-right: 40px;
  }

  .SetaPropostaRotate {
    margin-top: auto;
    cursor: pointer;
    margin-bottom: auto;
    margin-left: 40px;
  }
  .active {
    display: block;
  }

  .disable {
    display: none;
  }
  @media (min-width: 601px) {
    .SetaProposta {
      display: none;
    }

    .SetaPropostaRotate {
      display: none;
    }
  }
  .alice-carousel__dots {
    display: none;
  }
  .alice-carousel__stage {
    padding-left: 30px;
  }
`;

export const Header1 = styled.div`
  margin-bottom: 16px;
  text-align: center;
  font: normal normal bold 20px/27px Noto Sans, sans-serif;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-family: "Kanit";
`;

export const Header2 = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #212121;
  margin-bottom: 16px;
  font-family: "Open Sans", sans-serif;
`;

export const InputContainer = styled.div`
  height: 24px;
  opacity: 1;

  margin-bottom: 20px;
  font-family: "Open Sans", sans-serif;

  .InputRadioPF {
    width: 24px;
    height: 24px;
    opacity: 1;
    vertical-align: middle;
    accent-color: #138561;
  }

  .InputRadioPF:hover {
    cursor: pointer;
  }

  .InputRadioPJ {
    width: 24px;
    height: 24px;
    opacity: 1;
    vertical-align: middle;
  }

  .InputRadioPJ:hover {
    cursor: pointer;
  }

  input[type="radio"] {
    appearance: none;
    margin: 0 10px;
    width: 19px;
    height: 19px;
    box-shadow: inset 0 0 0 0.4em white, 0 0 0 0.1em #6c5af4;
    border-radius: 50%;
    transition: 0.2s;
    cursor: pointer;
    vertical-align: bottom;
  }
  input[type="radio"]:hover,
  input[type="radio"]:checked {
    box-shadow: inset 0 0 0 0.6em white, 0 0 0 0.1em;
  }
  input[type="radio"]:checked {
    background: #6c5af4;
    box-shadow: inset 0 0 0 0.3em white, 0 0 0 0.1em #6c5af4;
  }
  input[type="radio"]:focus {
    outline: 0;
  }
`;

export const InputContainerNomes = styled.div`
  grid-template-columns: auto auto;
  display: grid;

  @media (max-width: 700px) {
    grid-template-columns: auto;
  }

  .cpfInvalido {
    display: block;
    color: #bc0000;
    font-size: 12px;
    margin-left: 3px;
    margin-top: -15px;
    font-weight: bold;
    font-family: Open Sans, sans-serif;
  }

  @media (max-width: 700px) {
    .cpfInvalido {
      margin-top: -22px;
      margin-bottom: 15px;
    }
  }

  .cpfInvalidoDisabled {
    display: none;
  }

  .input-AXS {
    width: 313px;
    height: 54px;
    background: #f5f5f5;
    border-radius: 8px;
    border: none;
    outline: none;
    color: #757575;
    font-weight: 400;
    font-size: 14px;
    position: relative;
    margin-bottom: 30px;
  }

  .input-AXS input {
    width: 313px;
    height: 54px;
    background: #f5f5f5;
    border-radius: 8px;
    border: none;
    outline: none;
    color: #757575;
  }

  @media (max-width: 700px) {
    .input-AXS {
      width: 332px;
      height: 54px;
      background: #f5f5f5;
      border-radius: 8px;
      border: none;
      outline: none;
      color: #757575;
      font-weight: 400;
      font-size: 14px;
      position: relative;
      margin-bottom: 30px;
    }

    .input-AXS input {
      width: 332px;
      height: 54px;
      background: #f5f5f5;
      border-radius: 8px;
      border: none;
      outline: none;
      color: #757575;
    }
  }
`;

export const InputLabelPF = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #212121;
`;

export const InputLabelPJ = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #212121;
`;

export const InputGG = styled.div`
  grid-template-columns: auto;
  display: grid;

  @media (max-width: 700px) {
    grid-template-columns: auto;
  }

  .input-AXS {
    font-family: "Open Sans", sans-serif;
    width: 655px;
    height: 54px;
    background: #f5f5f5;
    border-radius: 8px;
    border: none;
    outline: none;
    color: #757575;
    font-weight: 400;
    font-size: 14px;
    position: relative;
    margin-bottom: 30px;
  }

  .input-AXS input {
    width: 643px;
    height: 54px;
    background: #f5f5f5;
    border-radius: 8px;
    border: none;
    outline: none;
    color: #757575;
    padding-left: 18px;
  }

  @media (max-width: 700px) {
    .input-AXS {
      width: 324px;
      height: 54px;
      background: #f5f5f5;
      border-radius: 8px;
      border: none;
      outline: none;
      color: #757575;
      font-weight: 400;
      font-size: 14px;
      position: relative;
      margin-bottom: 25px;
    }

    .input-AXS input {
      width: 324px;
      height: 54px;
      background: #f5f5f5;
      border-radius: 8px;
      border: none;
      outline: none;
      color: #757575;
    }
  }
`;

export const TextPrivacidade = styled.div`
  font-family: "Open Sans", sans-serif;
  @media (max-width: 700px) {
    margin-top: 34px;
    margin-bottom: 10px;
    margin-left: -142px;
    text-align: center;
  }

  text-align: left;
  text-decoration: underline;
  font-weight: 400;
  font-size: 14px;
  color: #616161;
  cursor: pointer;
  margin-top: 10px;
  margin-left: 23px;

  &:hover {
    text-decoration: none;
  }
`;
